import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import "./menu.css"

export default function Menu () {
    return (
        <Popup
            trigger={
                <div className='menu-item menu-button'>
                    Меню
                </div>
            }
            position="bottom center"
            on="click"
            closeOnDocumentClick
            mouseLeaveDelay={300}
            mouseEnterDelay={0}
            contentStyle={{ padding: '0px', border: 'none' }}
            arrow={false}
        >
            <div className="Menu">
                <a href="#news" className="menu-item">
                    Новости и события
                </a>
                {
                    //<a href="#calendar" className="menu-item">Календарь</a>
                }
                <a href="#for-specialists" className="menu-item">
                    Специалистам
                </a>
                <a href="#about" className="menu-item">
                    О нас
                </a>
            </div>
        </Popup>
        
    )
}